import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'
import { UserRoles } from '@/interfaces/enums'

const { t } = i18n.global

export const getCompanyUserSchema = (isEdit: boolean) => {
  return yup.object().shape({
    name: yup.string().required(t('errors.required', { label: 'Nome' })),
    email: yup.string().email(t('errors.invalid_email')).required(t('errors.required', { label: 'Email' })),
    phone: yup.string().required(t('errors.required', { label: 'Telefone' })),
    role: yup.string().oneOf(Object.values(UserRoles), t('errors.invalid_role')).required(t('errors.required', { label: 'Nível de Acesso' })),
    shift_id: yup.number().transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value)).nullable().notRequired(),
    receive_alerts: yup.boolean().notRequired(),
    receive_push: yup.boolean().notRequired(),
    receive_email: yup.boolean().notRequired(),
    receive_whatsapp: yup.boolean().notRequired(),
    password: isEdit
      ? yup.string().nullable().notRequired()
      : yup.string()
          .required(t('errors.required', { label: 'Senha' }))
          .min(8, t('errors.minLength', { label: 'Senha', min: 8 }))
          .matches(/^(?=.*[a-zA-Z])(?=.*[0-9])/, t('errors.alphanumeric', { label: 'Senha' })),
    password_confirmation: isEdit
      ? yup.string().nullable().notRequired()
      : yup.string()
          .required(t('errors.required', { label: 'Confirmação de senha' }))
          .oneOf([yup.ref('password')], t('errors.passwordMatch')),
  })
}
